import { createReducer, on } from '@ngrx/store'
import { ConcernedViewActions } from './action-types'
import { ConcernedDetailsMsg, ConcernedSubjectFullDto } from '../../../../api/backend'

const INIT_STATE: IConcernedViewState = {
    allConcerned: [],
    concernedDetails: null
}

export const concernedViewReducer = createReducer(
    INIT_STATE,
    on(ConcernedViewActions.setAllConcerned, (state, {data}): IConcernedViewState =>
       ({...state, allConcerned: data})
    ),
    on(ConcernedViewActions.setConcernedDetails, (state, {data}): IConcernedViewState =>
       ({...state, concernedDetails: data})
    ),
    on(ConcernedViewActions.resetState, (): IConcernedViewState => INIT_STATE),
)

export interface IConcernedViewState {
    allConcerned: Array<ConcernedSubjectFullDto>;
    concernedDetails: ConcernedDetailsMsg;
}